function komakiFormatMoney(amount, currencyCode) {
  try {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: currencyCode,
      maximumFractionDigits: 0
    }).format(amount);
  } catch (e) {
    return amount.toFixed(0);
  }
}

function komakiGetThreshold(currency) {
  const thresholds = {
    USD: 65,
    HKD: 520,
    EUR: 60,
    GBP: 50,
    CAD: 88,
    SGD: 87,
    JPY: 9800,
    AUD: 99
  };

  return thresholds[currency] || thresholds.USD;
}

async function komakiUpdateFreeShippingBars() {
  const bars = document.querySelectorAll('[data-komaki-free-shipping-bar]');
  if (!bars.length) return;

  try {
    const res = await fetch('/cart.js', {
      credentials: 'same-origin',
      cache: 'no-store'
    });

    if (!res.ok) {
      throw new Error('Failed to fetch cart.js');
    }

    const cart = await res.json();
    const total = (cart.total_price || 0) / 100;

    bars.forEach((bar) => {
      const textEl = bar.querySelector('[data-komaki-free-shipping-text]');
      const fillEl = bar.querySelector('[data-komaki-free-shipping-fill]');

      if (!textEl || !fillEl) return;

      const currency = bar.dataset.currency || 'USD';
      const threshold = komakiGetThreshold(currency);

      const initialText =
        '♡ ⋆｡˚ Free shipping on orders over ' +
        komakiFormatMoney(threshold, currency) +
        '˚｡⋆ ♡';

      const remaining = Math.max(0, threshold - total);
      const progress = Math.max(0, Math.min((total / threshold) * 100, 100));

      fillEl.style.width = progress + '%';

      if (total <= 0) {
        textEl.textContent = initialText;
      } else if (total >= threshold) {
        textEl.textContent = '♡ ⋆｡˚ You’ve unlocked free shipping!! ˚｡⋆ ♡';
      } else {
        textEl.innerHTML =
          '♡ You’re only <strong>' +
          komakiFormatMoney(remaining, currency) +
          '</strong> away from free shipping ♡';
      }
    });
  } catch (e) {
    const bars = document.querySelectorAll('[data-komaki-free-shipping-bar]');

    bars.forEach((bar) => {
      const textEl = bar.querySelector('[data-komaki-free-shipping-text]');
      const fillEl = bar.querySelector('[data-komaki-free-shipping-fill]');
      const currency = bar.dataset.currency || 'USD';
      const threshold = komakiGetThreshold(currency);

      if (!textEl || !fillEl) return;

      textEl.textContent =
        '♡ Free shipping on orders over ' +
        komakiFormatMoney(threshold, currency) +
        ' ♡';
      fillEl.style.width = '0%';
    });

    console.error('Komaki free shipping bar error:', e);
  }
}

let komakiUpdateTimer;

function komakiScheduleFreeShippingUpdate(delay = 200) {
  clearTimeout(komakiUpdateTimer);
  komakiUpdateTimer = setTimeout(() => {
    komakiUpdateFreeShippingBars();
  }, delay);
}

function komakiWatchCartDom() {
  if (document.body.dataset.komakiFreeShippingObserved === 'true') return;
  document.body.dataset.komakiFreeShippingObserved = 'true';

  const observer = new MutationObserver(() => {
    komakiScheduleFreeShippingUpdate(180);
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

function komakiInitFreeShippingBar() {
  komakiUpdateFreeShippingBars();
  komakiWatchCartDom();
}

document.addEventListener('DOMContentLoaded', komakiInitFreeShippingBar);
document.addEventListener('shopify:section:load', komakiInitFreeShippingBar);
document.addEventListener('pageshow', komakiInitFreeShippingBar);

document.addEventListener('change', function(e) {
  if (
    e.target.matches('input[name="updates[]"]') ||
    e.target.matches('.quantity__input') ||
    e.target.matches('input.quantity__input')
  ) {
    komakiScheduleFreeShippingUpdate(250);
    komakiScheduleFreeShippingUpdate(700);
  }
});

document.addEventListener('click', function(e) {
  if (
    e.target.closest('.quantity__button') ||
    e.target.closest('button[name="plus"]') ||
    e.target.closest('button[name="minus"]') ||
    e.target.closest('cart-remove-button') ||
    e.target.closest('.cart__remove')
  ) {
    komakiScheduleFreeShippingUpdate(250);
    komakiScheduleFreeShippingUpdate(700);
  }
});

/* 常見 theme 自訂事件，抓到就更新 */
document.addEventListener('cart:updated', function() {
  komakiScheduleFreeShippingUpdate(150);
});

document.addEventListener('ajaxProduct:added', function() {
  komakiScheduleFreeShippingUpdate(150);
});